export default "__VITE_ASSET__C839HahV__"